import React, { FC, useEffect, useState } from "react";
import { FormProaFEPresenter } from '@presenters/screens/form-proa-fe.presenter';
import { Container, Row } from 'reactstrap';
import styles from '../form-proa-subproject-fe.module.scss';
import { AEABatchGrid } from '@/components';
import { Utilities } from "@utils";
import ErrorTable from '@/components/ui/aea-error-table/aea-error-table';
export interface IBasicDataFE{
    dataColumns:any;
    index: number;
    startDate: any;
    endDate: any;
    step2: any;
    step3: any;
    step4: any;
    stepSDC: any;
    switchForm: boolean;
}

const GeneralSummaryFE: FC<IBasicDataFE> = (props) => {

    const [implementersProps, setImplementersProps] = useState(null);
    const [locationProps, setLocationProps] = useState(null);
    const [adtProps, setAdtProps] = useState(null);
    const [objetivesProps, setObjetivesProps] = useState(null);
    const [counterpartsProps, setCounterpartsProps] = useState(null);
    const [sumActivitiesProps, setSumActivitiesProps] = useState(null);

    const presenter = new FormProaFEPresenter({
        state: {
            dataColumns: props.dataColumns,
            setFirstDataGridProps: setImplementersProps,
            setSecondDataGridProps: setLocationProps,
            setThirdDataGridProps: setObjetivesProps,
            setFourthDataGridProps: setCounterpartsProps,
            setFifthDataGridProps: setAdtProps,
            setSixthDataGridProps: setSumActivitiesProps,
            step4: props.step4
        },
        implementersData: props.step2 || null,
        counterpartsData: props.stepSDC || null,
        zonaCCAAData: props.step3 || null,
        startDate: props.startDate,
        endDate: props.endDate
    });

    useEffect(()=>{ 
        presenter.initSummaryStep2(props.index);
    },[props.step2, props.startDate])

    useEffect(()=>{ 
        presenter.initSummaryStep3(props.index);
    },[props.step3, props.startDate])

    useEffect(()=>{ 
        presenter.initSummaryStepSDC(props.index);
    },[props.stepSDC, props.startDate])

    useEffect(()=>{ 
        presenter.initSummaryStep4(props.index);
    },[props.switchForm, props.step4, props.startDate])

    let existError = (!!implementersProps?.dataSource?.[0] && !!sumActivitiesProps?.dataSource?.[0]&&
        props.step3 !== undefined && props.step3 !== undefined && props.step4 !== undefined)  ? presenter.checkConsolidateValues(implementersProps?.dataSource?.[0], sumActivitiesProps?.dataSource?.[0], true) : null
    let exitErrorADt = (!!implementersProps?.dataSource?.[0] && !!locationProps?.dataSource?.[0] && !!sumActivitiesProps?.dataSource?.[0] &&
        props.step3 !== undefined && props.step3 !== undefined && props.step4 !== undefined) 
        ? presenter.checkConsolidateADT(adtProps?.dataSource?.[0], implementersProps?.dataSource?.[0], locationProps?.dataSource?.[0], sumActivitiesProps?.dataSource?.[0], true) : null

    const render = () => {
        return (
            <Container fluid={true}>
                 {existError?.message && 
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{existError.message}</h6>
                    </div>
                }
                {(exitErrorADt?.message) && 
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{exitErrorADt.message}</h6>
                    </div>
                }
                <Row className={styles.gridRow}>
                    {counterpartsProps ? 
                        <AEABatchGrid {...counterpartsProps} checkContent currentData={props.stepSDC !== undefined} ></AEABatchGrid>  : <div></div>
                    }
                </Row>
                <Row className={styles.gridRow}>
                    {(implementersProps?.gridProps?.id && !!implementersProps?.dataSource?.[0] && !!sumActivitiesProps?.dataSource?.[0] &&
                        props.step3 !== undefined && props.step3 !== undefined && props.step4 !== undefined) &&  
                        <ErrorTable 
                            gridId={implementersProps?.gridProps?.id} 
                            showAlerts={true}
                            checkFunction={(col, item) => presenter.checkConsolidateValues(item, sumActivitiesProps?.dataSource?.[0])}
                        />
                    }
                    {implementersProps ? 
                        <AEABatchGrid {...implementersProps} checkContent currentData={props.step2 !== undefined} ></AEABatchGrid>  : <div></div>
                    }
                </Row>
                <Row className={styles.gridRow}>
                    {locationProps ?
                        <AEABatchGrid {...locationProps} checkContent currentData={props.step3 !== undefined} ></AEABatchGrid> : <div></div>
                    }
                </Row>
                <Row className={styles.gridRow}>
                    {(adtProps?.gridProps?.id && !!implementersProps?.dataSource?.[0] && !!locationProps?.dataSource?.[0] && !!sumActivitiesProps?.dataSource?.[0] &&
                        props.step3 !== undefined && props.step3 !== undefined && props.step4 !== undefined) && 
                        <ErrorTable 
                            gridId={adtProps?.gridProps?.id} 
                            showAlerts={true}
                            checkFunction={(col, item) => presenter.checkConsolidateADT(item, implementersProps?.dataSource?.[0], locationProps?.dataSource?.[0], sumActivitiesProps?.dataSource?.[0])}
                        />
                    }
                    {adtProps ?
                        <AEABatchGrid {...adtProps} checkContent currentData={props.step3 !== undefined} ></AEABatchGrid> : <div></div>
                    }
                </Row>
                <Row className={styles.gridRow}>
                    {(sumActivitiesProps?.gridProps?.id && !!implementersProps?.dataSource?.[0] && !!sumActivitiesProps?.dataSource?.[0] &&
                        props.step3 !== undefined && props.step3 !== undefined && props.step4 !== undefined) && 
                        <ErrorTable 
                            gridId={sumActivitiesProps?.gridProps?.id} 
                            showAlerts={true}
                            checkFunction={(col, item) => presenter.checkConsolidateValues(item, implementersProps?.dataSource?.[0])}
                        />
                    }
                    {sumActivitiesProps ?
                        <AEABatchGrid {...sumActivitiesProps} checkContent currentData={props.step4 !== undefined} ></AEABatchGrid> : <div></div>
                    }
                </Row>
                <Row className={styles.gridRow}>
                    {objetivesProps ?
                        <AEABatchGrid {...objetivesProps} checkContent currentData={props.step4 !== undefined} ></AEABatchGrid> : <div></div>
                    }
                </Row>
            </Container>
        );
    }
    return render();
}

export default GeneralSummaryFE;